import axios from 'axios';
import get from 'lodash.get';
import { from } from 'rxjs';

import { emptyArray } from 'ui-components/default-props/empty';

export const getBatchDetails = (fulfillmentPlanSetId) => {
  const request = axios.get(`/fulfillmentPlanSet/${fulfillmentPlanSetId}`).then((response) => {
    return get(response, 'data', undefined);
  });

  const data$ = from(request);
  return data$;
};

export const removeFulfillmentPlansFromBatchPromise = (fulfillmentPlanSetId, fulfillmentPlanIds) => {
  return axios.put(`/fulfillmentPlanSet/${fulfillmentPlanSetId}/removeFulfillmentPlans`, {
    fulfillmentPlanIds,
  });
};

export const removeFulfillmentPlansFromBatch = (fulfillmentPlanSetId, fulfillmentPlanIds) => {
  return from(removeFulfillmentPlansFromBatchPromise(fulfillmentPlanSetId, fulfillmentPlanIds));
};

export const forceAddFulfillmentPlansPromise = (fulfillmentPlanSetId, fulfillmentPlanIds) => {
  return axios.put(`/fulfillmentPlanSet/${fulfillmentPlanSetId}/forceAddFulfillmentPlans`, {
    fulfillmentPlanIds,
  });
};

export const forceAddFulfillmentPlans = (fulfillmentPlanSetId, fulfillmentPlanIds) => {
  const put = forceAddFulfillmentPlansPromise(fulfillmentPlanSetId, fulfillmentPlanIds);
  const resp$ = from(put);
  return resp$;
};

export const rateBatch = (processFulfillmentPlanSet, fulfillmentPlanSetId, fulfillmentPlanIds) => {
  const batchRequestParams = {
    fulfillmentPlanSetId,
  };
  const bulkRequestParams = {
    fulfillmentPlanId: fulfillmentPlanIds,
  };
  const requestParams = processFulfillmentPlanSet ? batchRequestParams : bulkRequestParams;
  return axios.post('/bulk/rate', requestParams).then((response) => {
    return get(response, 'data', undefined);
  });
};

export const sendShipmentNotifications = (fulfillmentPlanIds) => {
  const post = axios
    .post('/bulk/sendEmail', { fulfillmentPlanId: fulfillmentPlanIds })
    .then((response) => get(response, 'data.jobGuids', emptyArray));
  const job$ = from(post);
  return job$;
};
